import {RestRequestGET} from "./RestRequest";
import downloadFile from "./downloadFile";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";
import previewFile from "./previewFile";


const downloadFileWithPreloadUrl = async (preloadUrl, openInBrowser, params) => {
    try {
        const resp = await RestRequestGET(preloadUrl, {params});
        if (resp?.success) {
            openInBrowser ?
                previewFile({url: resp.result}) :
                downloadFile({url: resp.result})
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')))
    }
}

export default downloadFileWithPreloadUrl;